import { apiGetAuth } from '@/utils/api'
import { API_ANALYTIC, API_EMPLOYEE } from '@/utils/api-url'
import {
  notificationDanger
} from '@/utils/notification'

const state = {
  employee_count_by_status: { 
    isLoading: false,
    data: {}
  },
  employee_percentage_by_status: {
    isLoading: false, 
    data: {}
  },
  employee_total_data_change: {
    isLoading: false,
    data: {}
  },
  total_claim: {
    isLoading: false,
    data: {}
  },
  total_employee: {
    isLoading: false,
    data: {}
  },
  investment_management_total: {
    isLoading: false,
    data: {}
  },
  summary: {
    isLoading: false,
    data: {}
  },
  recap_participant: {
    isLoading: false,
    data: {}
  },
  recap_company: {
    isLoading: false,
    data: {}
  },
  active_participant_count: { isLoading: false, data: 0 },
  meta_filter: {
    company_id: '',
    start_date: '',
    end_date: ''
  }
}

const mutations = {
  "SET_EMPLOYEE_COUNT_BY_STATUS": (state, payload) => {
    state.employee_count_by_status = payload
  },
  "SET_EMPLOYEE_PERCENTAGE_BY_STATUS": (state, payload) => {
    state.employee_percentage_by_status = payload
  },
  "SET_EMPLOYEE_TOTAL_DATA_CHANGE": (state, payload) => {
    state.employee_total_data_change = payload
  },
  "SET_TOTAL_CLAIM": (state, payload) => {
    state.total_claim = payload
  },
  "SET_TOTAL_EMPLOYEE": (state, payload) => {
    state.total_employee = payload
  },
  "SET_INVESTMENT_MANAGEMENT_TOTAL": (state, payload) => {
    state.investment_management_total = payload
  },
  "SET_SUMMARY": (state, payload) => {
    state.summary = payload
  },
  "SET_RECAP_PARTICIPANT": (state, payload) => {
    state.recap_participant = payload
  },
  "SET_RECAP_COMPANY": (state, payload) => {
    state.recap_company = payload
  },
  "SET_ACTIVE_PARTICIPANT_COUNT": (state, payload) => {
    state.active_participant_count = payload
  },
  "SET_META_FILTER": (state, payload) => {
    state.meta_filter = payload
  }
}

const actions = {
  async getEmployeeCountByStatus(context, payload) {
    try {
      context.commit('SET_EMPLOYEE_COUNT_BY_STATUS', { isLoading: true })
      const response = await apiGetAuth(API_ANALYTIC.EMPLOYEE_COUNT_BY_STATUS, payload)
      context.commit('SET_EMPLOYEE_COUNT_BY_STATUS', { 
        isLoading: false,
        data: response?.data?.data
      })
    } catch (err) {
      context.commit('SET_EMPLOYEE_COUNT_BY_STATUS', { 
        isLoading: false,
        data: {}
      })
      if(err?.response && err?.response?.data?.status !== 401) {
        notificationDanger(err)
      }
    }
  },
  async getEmployeePercentageByStatus(context, payload) {
    try {
      context.commit('SET_EMPLOYEE_PERCENTAGE_BY_STATUS', { isLoading: true })
      const response = await apiGetAuth(API_ANALYTIC.EMPLOYEE_PERCENTAGE_BY_STATUS, payload)
      context.commit('SET_EMPLOYEE_PERCENTAGE_BY_STATUS', { 
        isLoading: false,
        data: response?.data?.data
      })
    } catch (err) {
      context.commit('SET_EMPLOYEE_PERCENTAGE_BY_STATUS', { 
        isLoading: false,
        data: {}
      })
      if(err?.response && err?.response?.data?.status !== 401) {
        notificationDanger(err)
      }
    }
  },
  async getEmployeeTotalDataChange(context, payload) {
    try {
      context.commit('SET_EMPLOYEE_TOTAL_DATA_CHANGE', { isLoading: true })
      const response = await apiGetAuth(API_ANALYTIC.EMPLOYEE_TOTAL_DATA_CHANGE, payload)
      context.commit('SET_EMPLOYEE_TOTAL_DATA_CHANGE', { 
        isLoading: false,
        data: response?.data?.data
      })
    } catch (err) {
      context.commit('SET_EMPLOYEE_TOTAL_DATA_CHANGE', { 
        isLoading: false,
        data: {}
      })
      if(err?.response && err?.response?.data?.status !== 401) {
        notificationDanger(err)
      }
    }
  },
  async getTotalClaim(context, payload) {
    try {
      context.commit('SET_TOTAL_CLAIM', { isLoading: true })
      const response = await apiGetAuth(API_ANALYTIC.TOTAL_CLAIM, payload)
      context.commit('SET_TOTAL_CLAIM', { 
        isLoading: false,
        data: response?.data?.data
      })
    } catch (err) {
      context.commit('SET_TOTAL_CLAIM', { 
        isLoading: false,
        data: {}
      })
      if(err?.response && err?.response?.data?.status !== 401) {
        notificationDanger(err)
      }
    }
  },
  async getTotalEmployee(context, payload) {
    try {
      context.commit('SET_TOTAL_EMPLOYEE', { isLoading: true })
      const response = await apiGetAuth(API_ANALYTIC.TOTAL_EMPLOYEE, payload)
      context.commit('SET_TOTAL_EMPLOYEE', { 
        isLoading: false,
        data: response?.data?.data
      })
    } catch (err) {
      context.commit('SET_TOTAL_EMPLOYEE', { 
        isLoading: false,
        data: {}
      })
      if(err?.response && err?.response?.data?.status !== 401) {
        notificationDanger(err)
      }
    }
  },
  async getInvestmentManagementTotal(context, payload) {
    try {
      context.commit('SET_INVESTMENT_MANAGEMENT_TOTAL', { isLoading: true })
      const response = await apiGetAuth(API_ANALYTIC.COMPANY_INVESTMENT, payload)
      context.commit('SET_INVESTMENT_MANAGEMENT_TOTAL', { 
        isLoading: false,
        data: response?.data?.data
      })
    } catch (err) {
      context.commit('SET_INVESTMENT_MANAGEMENT_TOTAL', { 
        isLoading: false,
        data: {}
      })
      if(err?.response && err?.response?.data?.status !== 401) {
        notificationDanger(err)
      }
    }
  },
  async getSummary(context, payload) {
    try {
      context.commit('SET_SUMMARY', { isLoading: true })
      const response = await apiGetAuth(API_ANALYTIC.SUMMARY, payload)
      context.commit('SET_SUMMARY', {
        isLoading: false,
        data: response?.data?.data
      })
    } catch (err) {
      context.commit('SET_SUMMARY', {
        isLoading: false,
        data: {}
      })
    }
  },
  async getRecapParticipant(context, payload) {
    try {
      context.commit('SET_RECAP_PARTICIPANT', { isLoading: true })
      const response = await apiGetAuth(API_ANALYTIC.RECAP_PARTICIPANT, payload)
      context.commit('SET_RECAP_PARTICIPANT', {
        isLoading: false,
        data: response?.data?.data
      })
    } catch (err) {
      context.commit('SET_RECAP_PARTICIPANT', {
        isLoading: false,
        data: {}
      })
    }
  },
  async getActiveParticipantCount(context, payload) {
    try {
      context.commit('SET_ACTIVE_PARTICIPANT_COUNT', { isLoading: true, data: 0 })
      const params = { status: 'active', limit: 1 }
      if (payload?.company_id) params.company_id = payload.company_id
      if (payload?.start_date) params.start_date = payload.start_date
      if (payload?.end_date) params.end_date = payload.end_date
      const response = await apiGetAuth(API_EMPLOYEE.LIST, params)
      context.commit('SET_ACTIVE_PARTICIPANT_COUNT', {
        isLoading: false,
        data: response?.data?.other?.total || 0
      })
    } catch (err) {
      context.commit('SET_ACTIVE_PARTICIPANT_COUNT', { isLoading: false, data: 0 })
      if (err?.response && err?.response?.data?.status !== 401) {
        notificationDanger(err)
      }
    }
  },
  async getRecapCompany(context, payload) {
    try {
      context.commit('SET_RECAP_COMPANY', { isLoading: true })
      const response = await apiGetAuth(API_ANALYTIC.RECAP_COMPANY, payload)
      context.commit('SET_RECAP_COMPANY', {
        isLoading: false,
        data: response?.data?.data
      })
    } catch (err) {
      context.commit('SET_RECAP_COMPANY', {
        isLoading: false,
        data: {}
      })
    }
  }
}

const getters = {
  get_employee_count_by_status: state => {
    return state.employee_count_by_status
  },
  get_employee_percentage_by_status: state => {
    return state.employee_percentage_by_status
  },
  get_employee_total_data_change: state => {
    return state.employee_total_data_change
  },
  get_total_claim: state => {
    return state.total_claim
  },
  get_total_employee: state => {
    return state.total_employee
  },
  get_investment_management_total: state => {
    return state.investment_management_total
  },
  get_summary: state => {
    return state.summary
  },
  get_recap_participant: state => {
    return state.recap_participant
  },
  get_recap_company: state => {
    return state.recap_company
  },
  get_active_participant_count: state => {
    return state.active_participant_count
  },
  get_meta_filter: state => {
    return state.meta_filter
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
